import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import ThemeContextWrapper from "./components/ThemeWrapper/ThemeWrapper";
import BackgroundColorWrapper from "./components/BackgroundColorWrapper/BackgroundColorWrapper";
import './index.css';
import App from './App';

import "./assets/scss/black-dashboard-react.scss";
import "./assets/demo/demo.css";
import { Elements } from '@stripe/react-stripe-js';

import "./assets/css/nucleo-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_test_51KKcWOKNgqBeLJ9mCvKstO4a2wGZQ6TwbAmHA1V85COWfsOEBJUvklrjLJO9ohUwvy9AQwd3f129TH00WnfzqBsT00BA9fA6uJ');


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeContextWrapper>
    <BackgroundColorWrapper>
      <Elements stripe={stripePromise}>
        <App />
      </Elements>
    </BackgroundColorWrapper>
  </ThemeContextWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
